import React from "react";

export const plus = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="add_24px">
        <path
          id="icon/content/add_24px"
          d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
          fill="currentColor"
          fillOpacity="0.54"
        />
      </g>
    </svg>
  );
};
